export default __webpack_public_path__ + "static/media/newChat.422e085c.svg";